module.exports = __webpack_public_path__ + "static/media/02-0-img.4afa3350.png";